import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Flex, Spinner, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const { ready: workspaceReady } = useWorkspace();
  const { t } = useTranslation('common');

  const spinner = (
    <Flex
      minHeight="100vh"
      align="center"
      justify="center"
      direction="column"
      gap={4}
    >
      <Spinner size="xl" color="redesign.accent.blue" thickness="4px" />
      <Text color="redesign.text.muted">{t('states.loading')}</Text>
    </Flex>
  );

  if (loading) return spinner;
  if (!user) return <Navigate to="/login" replace />;
  // Authenticated but the active workspace isn't resolved yet. Holding here
  // keeps data pages from fetching before X-Workspace-Id is set, which would
  // 403/422 on first login. `ready` flips true even when the user has no
  // workspaces, so this never spins forever.
  if (!workspaceReady) return spinner;

  return <Outlet />;
};

export default ProtectedRoute;
